/**
 * Permission helpers. Centralising these so we don't sprinkle
 * `user?.role === 'admin'` literals everywhere — easier to audit and easier
 * to tweak the policy later.
 */

import { useAuth } from '../context/AuthContext';

/** True only for users with role === 'admin'. */
export const isAdmin = (user) => user?.role === 'admin';

/** Internal staff roles — everyone except external client SPOCs. */
const INTERNAL_ROLES = new Set(['admin', 'delivery_manager', 'team_lead', 'recruiter']);

/**
 * Revenue / CTC visibility policy.
 *
 * Per product decision (2026-05-24), revenue info — candidate offered CTC,
 * joined CTC, Joined-CTC × Location / Recruiter heatmaps, ClosureHealthReport,
 * Offer-vs-Joining ₹ chips, JobSummaryDrawer joined-CTC KPI, incentive math —
 * is visible to ALL internal roles (admin, delivery_manager, team_lead,
 * recruiter) but NOT to external client SPOCs.
 *
 * Mutating the incentive rate itself is still admin-only (enforced server-
 * side in /api/settings/incentive PUT).
 */
export const canSeeRevenue = (user) => INTERNAL_ROLES.has(user?.role);

/** React hook variant — reads `user` from AuthContext. */
export const useCanSeeRevenue = () => {
  const { user } = useAuth();
  return canSeeRevenue(user);
};
